import { useDecision } from '@optimizely/react-sdk'

export function useIsCheckoutBoxTangibilityEnabled() {
  const [boxTangibilityDecision] = useDecision('beetroots_ofx_checkout_box_tangibility')

  return boxTangibilityDecision.variationKey === 't1'
}
